<div #rootEl class="h-full w-2 transition-all" [class.w-8]="isWide()"></div>
